<!-- 保单信息 -->
<template>
  <div>
    <a-form-model :form="form"  :model="applicantInfo" :rules="editRules" :label-col="{ span: 5 }"
      :wrapper-col="{ span: 12 }">
      <div class="title_">
        <div class="cutleft_">保单信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-model-item :label-col="{ span: 3 }" label="起止日期" :wrapper-col="{ span: 21 }" prop="startDate">
        <a-row>
          <a-date-picker :disabled-date="disabledDate" :disabled="disabledAll" value-format="YYYY-MM-DD"
            placeholder="开始日期" v-model="applicantInfo.startDate" />
          <a-date-picker value-format="YYYY-MM-DD" :disabled-date="disabledEnd" :disabled="disabledAll"
            style="margin-left: 20px" placeholder="结束日期" v-model="endDate" />
        </a-row>
      </a-form-model-item>
      <div class="title_">
        <div class="cutleft_">投保人信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 6 }" label="名称" prop="name">
            <a-input :disabled="disabledAll" v-model.trim="applicantInfo.name" 
            @blur="queryCompanyCodeByName()" placeholder="请输入企业姓名" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 6 }" label="证件类型" prop="idType">
            <a-select :disabled="disabledAll" v-model="applicantInfo.idType" 
            @change="value => handleChange(value, 'idType')" placeholder="请选择证件类型">
              <a-select-option v-for="item in companyIdTypeOptions" :key="item.value" :value="item.value">
                {{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
					<div class="idNumber-form-item">
						<a-form-model-item :label-col="{ span: 6 }" label="证件号码" prop="idNumber">
							<a-input :disabled="disabledAll || applicantInfo.idType != '1'" v-model.trim="applicantInfo.idNumber" placeholder="请输入证件号码" />
						</a-form-model-item>
						<!-- 客服二维码组件 -->
						<customerService></customerService>
						</div>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 6 }" label="联系人姓名" prop="contactsname">
            <a-input :disabled="disabledAll" v-model.trim="applicantInfo.contactsname" placeholder="请输入联系人姓名" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 6 }" label="联系人证件号码" prop="legalIdnum">
            <a-input :disabled="disabledAll" v-model.trim="applicantInfo.legalIdnum" placeholder="请输入联系人证件号码" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 6 }" label="联系人手机" prop="contactsphone">
            <a-input :disabled="disabledAll" v-model.trim="applicantInfo.contactsphone" placeholder="请输入联系人手机" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 6 }" label="电子邮箱" prop="email">
            <a-input :disabled="disabledAll" v-model.trim="applicantInfo.email" placeholder="请输入电子邮箱" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 6 }" label="投保人地址" prop="provinceCity">
            <a-cascader :disabled="disabledAll" placeholder="请选择" style="width: 293px"
              v-model="applicantInfo.provinceCity" :options="addressOptions" :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children',
              }" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 6 }" label="详细地址" prop="address">
            <a-input :disabled="disabledAll" v-model.trim="applicantInfo.address" placeholder="请输入详细地址" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <div class="title_">
        <div class="cutleft_">工程项目信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-row>
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 6 }" label="项目名称" prop="projectName">
            <a-input :disabled="disabledAll" v-model.trim="applicantInfo.projectName" placeholder="请输入项目名称" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 6 }" label="施工地址" prop="constructionProvinceCity">
            <a-cascader :disabled="disabledAll" placeholder="请选择" style="width: 293px"
              v-model="applicantInfo.constructionProvinceCity"
              @change="(value, label) => handleChange(value, 'constructionProvinceCity', label)"
              :options="addressOptions2" :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children',
              }" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 6 }" label="详细地址" prop="constructionAddr">
            <a-input :disabled="disabledAll" v-model.trim="applicantInfo.constructionAddr" placeholder="请输入详细地址" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 6 }" label="工程造价" prop="projectamount">
            <a-input-number :disabled="disabledAll" :min="0" style="width: 100%" @change="countPremiumSum"
              v-model.trim="applicantInfo.projectamount" :placeholder="projectCostsHelp" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 6 }" label="雇员人数" prop="stature">
            <a-input-number :disabled="disabledAll" :min="0" style="width: 100%" v-model.trim="applicantInfo.stature"
              placeholder="请输入雇员人数" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 6 }" label="支付方式" prop="payMethod">
            <a-select :disabled="disabledAll" v-model="applicantInfo.payMethod" placeholder="请选择支付方式">
              <a-select-option v-for="item in payTypeList" :key="item.value" :value="item.value">{{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <div class="title_">
        <div class="cutleft_">受益人信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-row>
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 6 }" label="本保单受益人">
            <a-input :disabled="disabledAll" v-model.trim="applicantInfo.onlybeneficiary1" placeholder="请输入本保单受益人" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 6 }" label="本保单共同被保险人">
            <a-input :disabled="disabledAll" v-model.trim="applicantInfo.onlybeneficiary2"
              @blur="value => handleChange(value, 'onlybeneficiary2')" placeholder="请输入本保单共同被保险人" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <!-- 发票信息 -->
      <div class="title_">
        <div class="cutleft_">开票信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-row>
        <a-row>环保节约，提倡电子发票，如需纸质版本，请自行打印，系统将通过邮件及手机短信发送电子发票，请注意查收。</a-row>
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 4 }" label="发票类型">
            <a-select disabled placeholder="请选择" v-model="applicantInfo.invoiceprinttype">
              <a-select-option value="01">暂不开票</a-select-option>
              <a-select-option value="03">电子发票</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12" v-if="applicantInfo.invoiceprinttype == '03'">
          <a-form-model-item :label-col="{ span: 6 }" label="纳税人识别号">
            <a-input placeholder="请输入纳税人识别号" v-model="applicantInfo.taxpayercertificateno" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <div class="title_">
          <div class="cutleft_">总保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-form-model-item label="保费" :label-col="{ span: 1 }">
          <a-col :span="6">
            <a-input :value="totalPremium" disabled style="width: 130px" addonAfter="元" />
          </a-col>
        </a-form-model-item>
      </a-row>
      <a-row :gutter="24" class="btn_list" v-show="disabledAll">
        <div class="title_">
          <div class="cutoff_"></div>
        </div>
        <a-checkbox :disabled="!agreementAllRead" @change="onChangeyueduBtn" style="margin-bottom: 20px">
          投保人已充分阅读、理解并同意
          <fileView></fileView>
        </a-checkbox>
      </a-row>
      <a-row class="order">
        <a-col :span="24">
          <a-form-model-item :wrapper-col="{ span: 12, offset: 10 }">
            <a-button class="btn_color" type="primary" :loading="submitLoad1" v-show="!disabledAll"
              @click="handleSubmit">保存订单</a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll"
              @click="fastInsure"> 立即投保 </a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="gonOne">编辑
            </a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <!-- 支付的弹窗 -->
    <a-modal class="myModal_" width="500px" title="支付确认" forceRender v-model="showPaySure" @ok="paySure" okText="确定"
      cancelText="关闭">
      <p style="text-align: center; font-size: 18px; margin-bottom: 0; padding: 20px; line-height: 30px">
        您投保的{{ productName() }}需支付保费 <span style="color: #fe8f2d; font-weight: bold"> {{ totalPremium }} </span>&nbsp;元
      </p>
    </a-modal>
  </div>
</template>

<script>
  import moment from 'moment';
  let DATA = require('../data').default;
  import { policyMixin } from '@/mixins/policyMixin.js';
	import { idNumberMixins } from '@/mixins/idNumberMixins.js';
  export default {
    //import引入的组件需要注入到对象中才能使用
    mixins: [policyMixin, idNumberMixins],
    data() {
      //这里存放数据
      return {
        planList: DATA.plansValues, //计划列表
        form: this.$form.createForm(this, { name: 'advanced_search' }),
        companyIdTypeOptions: DATA.companyIdTypeOptions, //证件类型
        constructionType: DATA.constructionType, //施工类型
        columns: DATA.columns, //关联
        otherInfo: '', //限制勾选的地区
        disabledAll: false,
        yueduBtn: false, //阅读中
        submitLoad1: false, //保存中
        submitLoad2: false, //提交中
        showPaySure: false, //支付
        policyId: '', //支付回来的id
        mon: '6', //月份
        invoiceNo: '', //上传文件的唯一key
        totalPremium: 0,
        applicantInfo: {
          planCode: '', //计划code
          startDate: '', //投保起始日期
          quality: '01', //客户性质
          name: '', //名称（中文）
          //engName: '', //名称（英文）
          idType: '', //证件类型
          idNumber: '', //证件号码
          contactsname: '', //联系人姓名
          onlybeneficiary1: '',
          onlybeneficiary2: '',
          // onlybeneficiary3: '',
          contactsphone: '', //联系人电话
          legalIdnum: '', //联系人证件号码
          email: '', // 邮箱
          provinceCity: [],
          address: '', //详细地址
          projectName: '', //项目名称
          constructionProvinceCity: [], //施工地址
          constructionAddr: '', //施工详细地址
          projectamount: '', //工程造价
          stature: '', //被保险人人数
          constructionStartDate: '', //施工日期start
          constructionEndDate: '', //施工日期end

          relatePerson: [], //关联投保人

          fileList: [], //文件列表

          invoiceprinttype: '01', //发票类型
          taxpayercertificateno: '', //纳税人识别号
          payMethod: '', //支付方式
        },
        editRules: {
          startDate: [{ required: true, message: '请选择', trigger: 'blur' }],
          name: [{ required: true, message: '请输入', trigger: 'blur' }],
          idType: [{ required: true, message: '请选择', trigger: 'change' }],
          idNumber: [{ required: true, message: '请输入', trigger: 'blur' }],
          contactsname: [{ required: true, message: '请输入', trigger: 'blur' }],
          legalIdnum: [{ required: true, message: '请输入', trigger: 'blur' }],
          contactsphone: [{ required: true, message: '请输入正确手机号', trigger: 'blur', pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/ }],
          email: [{ required: true, message: '请输入邮箱', trigger: 'blur', pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ }],
          provinceCity: [{ required: true, message: '请选择', trigger: 'change' }],
          address: [{ required: true, message: '请输入', trigger: 'blur' }],
          constructionType: [{ required: true, message: '请选择', trigger: 'change' }],
          projectName: [{ required: true, message: '请输入', trigger: 'blur' }],
          constructionProvinceCity: [{ required: true, message: '请选择', trigger: 'change' }],
          constructionAddr: [{ required: true, message: '请输入', trigger: 'blur' }],
          projectamount: [{ required: true, message: '请输入', trigger: 'blur' }],
          stature: [{ required: true, message: '请输入', trigger: 'blur' }],
          constructionStartDate: [{ required: true, message: '请选择', trigger: 'blur' }],
          payMethod: [{ required: true, message: '请选择', trigger: 'change' }],
        },
        RiskInfos: {
          riskInfos: [],
          salPolicy: {
            productCode: 'HAZXB', //产品code
            bracket: 1, //保费期限
          },
          salPolicyExt: {
            isworkheightinvolved: 2,
            architecture: '',
          },
          salPolicyHolder: {
            addfifty: '2', // 测算类型
            stature: 2, //是否高空（2-否，1-是）
          },
          premiumBaseDtoList: [], //人数
        }, //测算的数据
        loading: false,
        modalVisible: false, //修改保费的弹窗
        creator: '1',
        productCode: '',
        pacCode: [], //省市区的数组
        pacCode1: [], //省市区的数组
        plan: '',
        endDate: "",
      };
    },
    //监听属性 类似于data概念
    computed: {
      
      // endDate() {
      //   let mon = 12;
      //   let date = this.applicantInfo.startDate;
      //   let t2;
      //   if (date && mon) {
      //     t2 = moment(date).add(mon, 'months').subtract(1, 's');
      //   }
      //   return t2;
      // },
      addressOptions() {
        let dataArr = this.$lodash.cloneDeep(window.addrescode);
        return dataArr;
      },
      addressOptions2() {
        let dataArr = this.$lodash.cloneDeep(window.addrescode);
        return dataArr;
      },
      //工程造价
      projectCostsHelp() {
        let txt = '工程造价';
        let itemOne = this.planList.find(item => item.value == this.applicantInfo.planCode);
        if (itemOne) {
          txt = itemOne.money1;
        }
        return txt;
      },
    },
    mounted() {
      this.$bus.$on('onRiskInfos', (data, init) => {
        
        let strdata = this.$lodash.cloneDeep(data);
        this.RiskInfos.riskInfos = strdata.riskInfos;
        this.RiskInfos.salPolicy = strdata.salPolicy;
        this.RiskInfos.salPolicyHolder = strdata.salPolicyHolder;
        this.applicantInfo.projectamount = strdata.salPolicyHolder.projectamount
        if(!init) {
          this.countPremiumSum();
        }
      });
    },
    //方法集合
    methods: {
      moment,
      productName() {
        return sessionStorage.getItem('productName')
      },
      handleChange(value, type, label) {
        if (type == 'constructionProvinceCity') {
          this.pacCode = label;
        }
        if (type == 'onlybeneficiary2') {
          if (!this.applicantInfo.onlybeneficiary1) {
            this.$message.error('请先填写本保单受益人！');
            this.applicantInfo.onlybeneficiary2 = '';
          }
        }

      if (type == 'idType') {
        this.queryCompanyCodeByName();
      }
        // if (type == 'onlybeneficiary3') {
        //   if (!this.applicantInfo.onlybeneficiary2) {
        //     this.$message.error('请先填写第二受益人！');
        //     this.applicantInfo.onlybeneficiary3 = '';
        //   }
        // }
      },
      //新增关联投保人
      addRelationPerson() {
        this.applicantInfo.relatePerson.push({
          companyName: '',
        });
      },
      //删除关联人
      delRecord(idx) {
        this.$Modal.confirm({
          title: '删除关联投保人?',
          content: '确定删除该关联投保人',
          okText: '确定',
          cancelText: '取消',
          onOk: () => {
            this.applicantInfo.relatePerson.splice(idx, 1);
          },
        });
      },
      //理解并阅读
      onChangeyueduBtn(e) {
        this.yueduBtn = e.target.checked;
      },
      //获取选择的省市名称
      getChooseAreaName(arr) {
        let dataArr = window.addrescode;
        for (let i = 0; i < dataArr.length; i++) {
          let provinceObj = dataArr[i];
          if (provinceObj.value == arr[0]) {
            for (let j = 0; j < provinceObj.children.length; j++) {
              let cityObj = provinceObj.children[j];
              if (cityObj.value == arr[1]) {
                return {
                  province: provinceObj.text,
                  city: cityObj.text,
                };
              }
            }
          }
        }
      },
      //编辑
      gonOne() {
        this.disabledAll = false;
        this.$bus.$emit('disabledBus', false);
        this.$router.push({
          name: 'hazxb',
          query: {
            u: this.$route.query.u,
            p: this.$route.query.p,
            sign: this.$route.query.sign,
            planCode: this.$route.query.planCode,
          },
        });
      },
      //保费试算
      countPremiumSum() {
        if (this.applicantInfo.projectamount > 10000000) {
          this.applicantInfo.projectamount = ''
          this.$message.error('工程造价不能超过1000万！');
          return
        }
        let data = {
          riskInfos: this.RiskInfos.riskInfos, //险种信息
          salPolicy: this.RiskInfos.salPolicy,
          salPolicyExt: this.RiskInfos.salPolicyExt,
          salPolicyHolder: this.RiskInfos.salPolicyHolder,
          premiumBaseDtoList: [], //人数
        };
        if (!this.applicantInfo.projectamount) {
          return;
        }
        data.salPolicyHolder.projectamount = this.applicantInfo.projectamount;
        this.$api.calPremiumEmployer(data).then(res => {
          if (res.data.success) {
            let data = res.data.content;
            this.totalPremium = data.totalPremium;
          } else {
            this.$message.error(res.data.returnMsg + '错误');
          }
        });
      },

      filterPcode(arr) {
        let str;
        if (arr && arr.length) {
          if (isNaN(parseInt(arr[0]))) {
            str = 'text';
          } else {
            str = 'value';
          }
          if (!str) return;
          try {
            var addressOptions = this.$lodash.cloneDeep(this.addressOptions);
            var oneArr = addressOptions.filter(item => arr[0] == item[str]) || [];
            var twoArr = oneArr[0].children.filter(item => arr[1] == item[str]) || [];
            var threeArr = twoArr[0].children.filter(item => item[str] == arr[2]) || [];
            sessionStorage.setItem('pacCode', threeArr[0].value);
          } catch (error) {
            throw new Error(error);
          }
          return {
            code: [oneArr[0] ? oneArr[0].value : '', twoArr[0] ? twoArr[0].value : '', threeArr[0] ? threeArr[0].value : ''],
            arrCode: [oneArr[0], twoArr[0], threeArr[0]],
          };
        }
      },
      queryOrderDetails() {
        // 查询保单信息
        let parms = {
          policyId: this.$route.query.policyId,
        };
        this.$api.queryOrderDetails(parms).then(res => {
          if (res.data.returnCode == 0) {
            if (res.data.content) {
              let orderContent = res.data.content;
              this.$store.commit('setOrderContent', orderContent);
              if (res.data.content.riskInfos) {
                this.RiskInfos.riskInfos = orderContent.riskInfos;
              }
              this.invoiceNo = orderContent.salPolicyHolder.invoiceno || '';
              this.RiskInfos.salPolicy = orderContent.salPolicy;
              this.RiskInfos.salPolicyHolder = orderContent.salPolicyHolder;
              this.totalPremium = orderContent.salPolicy.totalPremium;
              this.$bus.$emit('busRiskInfos', this.RiskInfos);
              let onlybeneficiary = []
              if (orderContent.salPolicyHolder.onlybeneficiary && orderContent.salPolicyHolder.onlybeneficiary.indexOf('；本保单共同被保险人：') > -1) {
                onlybeneficiary = orderContent.salPolicyHolder.onlybeneficiary.split('；本保单共同被保险人：');
              } else {
                onlybeneficiary = orderContent.salPolicyHolder.onlybeneficiary.split(',');
              }
              this.endDate = orderContent.salPolicy.expireDate;
              this.pacCode = this.filterPcode((orderContent.salPolicyHolder.projectarea || '').split('-') || []).arrCode;
              this.applicantInfo = {
                planCode: orderContent.salPolicy.planCode, //计划code
                startDate: orderContent.salPolicy.effectiveDate, //投保起始日期
                quality: '01', //客户性质
                name: orderContent.salPolicyHolder.name, //名称（中文）
                engName: '', //名称（英文）
                idType: orderContent.salPolicyHolder.idType, //证件类型
                legalIdnum: orderContent.salPolicyHolder.legalIdnum, //联系人号码
                idNumber: orderContent.salPolicyHolder.idNumber, //证件号码
                contactsname: orderContent.salPolicyHolder.contactsname, //联系人姓名
                contactsphone: orderContent.salPolicyHolder.telephone, //联系人电话
                email: orderContent.salPolicyHolder.email, // 邮箱
                provinceCity: (orderContent.salPolicyHolder.addresscode || '').split('-').map((item) => { return item}),
                address: orderContent.salPolicyHolder.address, //详细地址
                projectName: orderContent.salPolicyHolder.projectname, //项目名称
                constructionProvinceCity: (orderContent.salPolicyHolder.projectarea || '').split('-').map((item) => { return item}), //施工地址
                constructionAddr: orderContent.salPolicyHolder.projectaddress, //施工详细地址
                projectamount: orderContent.salPolicyHolder.projectamount, //工程造价
                constructionStartDate: orderContent.salPolicyHolder.planProjectDate, //施工日期start
                constructionEndDate: orderContent.salPolicyHolder.expirationDate, //施工日期end
                stature: orderContent.salPolicyHolder.stature, // 被保险人数
                relatePerson: [], //关联投保人
                invoiceprinttype: orderContent.salPolicyHolder.invoiceprinttype, //发票类型
                taxpayercertificateno: orderContent.salPolicyHolder.taxpayercertificateno, //纳税人识别号
                payMethod: orderContent.salPolicy.payMethod, //支付方式
                onlybeneficiary1: onlybeneficiary && onlybeneficiary[0],
                onlybeneficiary2: onlybeneficiary && onlybeneficiary[1],
                // onlybeneficiary3: onlybeneficiary && onlybeneficiary[2],
              };
              
            }
          }
        });
      },
      //验证手机号的
      idPhoneChange(e) {
        let val = e.target.value;
        if (!this.$checkPhone.test(val)) {
          this.$message.error('请输入正确的联系人手机号', 3);
        }
      },
      queryCompanyCodeByName() {
        if (!this.applicantInfo.idType || this.applicantInfo.idType == 1) return;
        if (this.applicantInfo.idType == 1) return;
        this.queryCompanyIdNumber(this.applicantInfo.name, 1);
      },
      //开始时间
      disabledDate(current) {
        return (current && current < moment().endOf('day')) || current > moment().add(30, 'day');
      },
      disabledEnd(current) {
        return current && current < moment(this.applicantInfo.startDate).add(1, 'day') || current > moment(this.applicantInfo.startDate).add(12, 'months');
      },
      //最后的提交
      handleSubmit() {
        this.form.validateFields((err) => {
          if (!err) {
            let base = this.applicantInfo;
            let provinceCity = this.getChooseAreaName(this.applicantInfo.provinceCity);
            
            let data = {
              riskInfos: this.RiskInfos.riskInfos,
              salInsuredList: [
                {
                  name: base.name, //name  投保人名称
                  idType: base.idType, //证件类型
                  idNumber: base.idNumber, //证件号码
                  linkmanname: base.contactsname, // 联系人姓名
                  mobile: base.contactsphone, // 联系人手机
                  email: base.email, //联系人邮箱
                },
              ],
              salPolicy: {
                //保单信息
                planCode: this.RiskInfos.salPolicy.planCode, //产品计划
                productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
                creator: this.creator,
                effectiveDate: base.startDate, //startTime  保单生效时间
                id: this.policyId,
                expireDate: moment(this.endDate).format('YYYY-MM-DD'), //endTime   保单终止时间
                payMethod: base.payMethod, //支付方式”
                totalPremium: this.totalPremium, //totalPremium  总保费
              },
              //投保人信息
              salPolicyHolder: {
                occupationcodesh: this.RiskInfos.salPolicyHolder.occupationcodesh,
                invoiceno: this.invoiceNo || '', //文件上传的唯一key
                type: 'C', //固定值
                name: base.name, //name  投保人名称
                idType: base.idType, //证件类型
                idNumber: base.idNumber, //证件号码
                legalIdnum: base.legalIdnum, //联系人号码
                contactsname: base.contactsname, // 联系人姓名
                telephone: base.contactsphone, // 联系人手机
                email: base.email, //联系人邮箱
                province: provinceCity.province,
                city: provinceCity.city,
                address: base.address, //详细地址
                addresscode: base.provinceCity.join('-'), //省市编码
                projectamount: base.projectamount, //工程造价
                projectname: base.projectName, //项目名称
                projectarea: `${base.constructionProvinceCity.join('-')}`, // 施工地址省市区编码
                occupationnamesh: `${this.pacCode[0].text}-${this.pacCode[1].text}-${this.pacCode[2].text}`, // 施工地址
                projectaddress: `${base.constructionAddr}`, //施工地址
                enttypecode: base.constructionNature, //工程资质
                stature: base.stature, // 被保险人数
                gztypestr: base.constructionType, //工程类型
                planProjectDate: base.constructionStartDate, //工程开始时间
                expirationDate: base.constructionEndDate, // 工程结束时间
                invoiceprinttype: base.invoiceprinttype, //"发票类型，电子普通发票：01、暂不开票：03",
                taxpayercertificatetype: base.invoiceprinttype == '01' ? base.taxpayercertificateno : '01',
              },
            };
            if (base.onlybeneficiary2) {
              data.salPolicyHolder.onlybeneficiary = `${base.onlybeneficiary1}；本保单共同被保险人：${base.onlybeneficiary2}`
            } else {
              data.salPolicyHolder.onlybeneficiary = base.onlybeneficiary1
            }
            if (this.$route.query.policyId) {
              data.policyId = this.$route.query.policyId;
            }
            this.submitLoad1 = true;
            this.axiosPolicy(data); // 保存订单是 直接保存
          } else {
            this.$message.error('请填写完整提交的数据');
          }
        });
      },
      //立即投保
      fastInsure() {
        if (!this.yueduBtn) {
          this.$message.warning('请确认已充分阅读、理解并同意《保险条款》《投保须知》《责任免除》', 2);
          return;
        }
        this.showPaySure = true;
      },
      axiosPolicy(data) {
        //提交保单
        this.$store.commit('setLoading', { show: true, text: '保存中...' });
        this.$api
          .addPAPolicy(data)
          .then(res => {
            if (res.data.returnCode == '00') {
              this.showPaySure = false;
              this.policyId = res.data.content;
              this.$message.success('保存成功！');
              this.$router.push({
                name: 'hazxb',
                query: {
                  u: this.$route.query.u,
                  p: this.$route.query.p,
                  sign: this.$route.query.sign,
                  policyId: this.policyId,
                  planCode: this.$route.query.planCode,
                  continuation: '1'
                },
              });
              this.disabledAll = true;
              this.$bus.$emit('disabledBus', true);
            }
          })
          .finally(() => {
            this.$store.commit('setLoading', { show: false });
            this.submitLoad1 = false;
          });
      },
      paySure() {
        //支付确认
        this.showPaySure = false;
        this.submitLoad1 = false;
        this.submitLoad2 = false;
        this.policyId = this.$route.query.policyId;
        this.$payModal({
          show: true,
          type: 'hazxb', //产品类型
          policyId: this.policyId, //产品id
          creator: this.creator, //用户id
          payMethod: this.applicantInfo.payMethod, //支付方式
          productCode: this.$route.query.p, //产品code
          totalPremium: this.totalPremium, //支付总金额
        });
      },
    },
  };
</script>
<style scoped lang="scss">
  .avatar-uploader>>>.ant-upload {
    width: 128px;
    height: 128px;
  }

  .avatar-uploader>>>.ant-upload img {
    width: 100%;
    height: 100%;
  }

  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .btn_color {
    margin: 0 20px;
  }

  .red {
    color: red;
  }
</style>

<style lang="scss">
  .page_hide_upload_file_list_ {
    .ant-upload-list {
      display: block !important;
    }
  }
</style>